import { Review } from '@/interfaces/Product'
import { AxiosPromise } from 'axios'
import { client } from '.'

export interface GetReviewsResponse {
  count: {
    all: number
    5: number
    4: number
    3: number
    2: number
    1: number
  }
  reviews: Review[]
  pages: number
  currentPage: number
  ratingFilter: number
}

interface GetReviewOptions {
  productId: number
  page?: number
  ratingFilter?: number
}

export function getReviews(
  options: GetReviewOptions
): AxiosPromise<GetReviewsResponse> {
  return client.get('/product_review', {
    params: {
      productId: options.productId,
      page: options.page,
      ratingFilter: options.ratingFilter,
    },
  })
}

export function voteReview(reviewId: number): AxiosPromise<number> {
  return client.post('/product_review/vote', null, {
    params: {
      reviewId,
    },
  })

}
export function hasReviewed(productId: number): AxiosPromise<number> {
  return client.post('/product_review/hasreviewed', null, {
    params: {
      productId,
    },
  })
}
